import React from 'react';

const PageTransition = ({ children }) => {
    return (
        <div className="page-transition">
            {children}
        </div>
    );
};

export default PageTransition;
